//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.StructureDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../Features/Features.StructureDesign.InheritStockBuilder.js";
import "../no/SelectTaggedObjectList.js";
import "../no/ScCollector.js";
import "../Features/Features.StructureDesign.FeatureSpreadsheetBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
let d=[[[0,"AlternateOrigin",1,0],[0,"EnableTransform",1,0],[1,"EndLimit",0,"Expression",0],[1,"InheritStock",0,"Features.StructureDesign.InheritStockBuilder",0],[1,"Member",0,"SelectTaggedObjectList",0],[1,"MemberCurveEdge",0,"ScCollector",0],[1,"MemberFacePlane",0,"ScCollector",0],[1,"ReferenceCurveEdge",0,"ScCollector",0],[1,"ReferenceFacePlane",0,"ScCollector",0],[1,"RotateAngle",0,"Expression",0],[0,"SelectionType",1,0],[1,"StartLimit",0,"Expression",0],[1,"StockData",0,"Features.StructureDesign.FeatureSpreadsheetBuilder",0],[1,"XOffset",0,"Expression",0],[1,"YOffset",0,"Expression",0]],[[[],"FlipX",{},0,0],[[],"FlipY",{},0,0],[["member"],"UpdateStockInformation",{},1,0]],[]];
SPLM.Features.StructureDesign.EditStockBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.StructureDesign.EditStockBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.StructureDesign.EditStockBuilder.AlignMemberSelectionType = Object.freeze({
    "FacePlane" : "FacePlane", "CurveEdge" : "CurveEdge"});

export default SPLM;